import { render, staticRenderFns } from "./Base64Svg.vue?vue&type=template&id=12e661bd"
import script from "./Base64Svg.vue?vue&type=script&lang=js"
export * from "./Base64Svg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports